import http from './httpService';

const apiEndPoint = '/contact';

export function sendContactMessage(body) {
  return http.post(apiEndPoint, body);
}
